import { Box, Button, DashboardModule } from '@domain-group/suit-theme'

import useAgencySelector from '@hooks/useAgencySelector'
import useRoles from '@hooks/useRoles'
import useUser from '@hooks/useUser'
import useUsers from '@hooks/useUsers'

import UserListItem from '../UserListItem'
import UsersBlankState from '../UsersBlankState'

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const OfficeAdministrators = (props: PageContentProps) => {
  const { pageFilters } = props

  const { selectedAgencyId } = useAgencySelector()

  const usersPayload = useUsers({
    filters: {
      actable_types: ['OfficeAdministrator'],
      agency_id: selectedAgencyId,
      brand_user: false,
      ...pageFilters,
    },
    performHttpRequests: true,
    requestOptions: {
      include_image_sizes: true,
      include_user_association_id: true,
      include_user_image: true,
      include_user_type: true,
    },
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filteredUsers,
    filteredUsersCount,
    hasFilteredUsers,
    loading,
  } = usersPayload

  const { filteredRoles } = useRoles({ filters: { string: 'Office Administrator' } })

  const {
    callbacks: { addUser },
  } = useUser(
    {
      association_id: selectedAgencyId,
      association_type: 'Agency',
      role_id: filteredRoles[0]?.id,
    },
  )

  return (
    <DashboardModule loading={loading} title="Office Administrators">
      <Box flexDirection="column">
        {!loading && !hasFilteredUsers && (
          <UsersBlankState title="No Office Administrators" />
        )}

        {!loading && hasFilteredUsers && (
          <DashboardModule.ScrollableSection>
            {filteredUsers.map(user => (
              <UserListItem
                // @ts-expect-error TS2322
                agencyId={selectedAgencyId}
                key={user.id}
                user={user}
              />
            ))}
          </DashboardModule.ScrollableSection>
        )}

        <DashboardModule.LoadMoreFooter
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredUsersCount}
          // @ts-expect-error TS2322
          loading={loading}
          showBorderTop={!loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            onClick={() => addUser()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Admin
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default OfficeAdministrators
